var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.715 16.188a1 1 0 0 1 .285.7V30a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 0 30V10a2.5 2.5 0 0 1 2.5-2.5h8.28a1 1 0 0 1 .715.3zM19.895 9c-.77 0-1.395-.624-1.395-1.395V2l7 7zm-7.5 7.5H18l-7-7v5.605c0 .77.625 1.395 1.395 1.395m14.82-7.812L18.995.3a1 1 0 0 0-.715-.3H10a2.5 2.5 0 0 0-2.5 2.5V6h3.836a1 1 0 0 1 .707.293l9.165 9.164a1 1 0 0 1 .292.708V25H25a2.5 2.5 0 0 0 2.5-2.5V9.388a1 1 0 0 0-.285-.7"
  })));
};
export default SvgCopy;